import { Component } from "react";
import ReactGA from "react-ga4";

import { googleAnalytics } from "resources/constants";

interface IProps {
  location: {
    pathname: string;
    search: string;
  };
}

class Tracking extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
    ReactGA.initialize(googleAnalytics);
  }

  componentDidMount() {
    const { location } = this.props;
    this.logPageChange(location.pathname, location.search);
  }

  componentDidUpdate(prevProps: IProps) {
    const { location } = this.props;
    if (
      location.pathname !== prevProps.location.pathname ||
      location.search !== prevProps.location.search
    ) {
      this.logPageChange(location.pathname, location.search);
    }
  }

  logPageChange = (pathname: string, search = "") => {
    ReactGA.send({ hitType: "pageview", page: `${pathname}${search}` });
  };

  render() {
    return null;
  }
}

export default Tracking;
